module.exports = __webpack_public_path__ + "static/media/ohio.03d58927.jpg";